import Broadcast from "../models/Broadcast";
import Contact from "../models/Contacts";
import Groups from "../models/Groups";
import request from "../shared/http";
import appConfig from "../shared/js/app-config";

class BroadcastService {
  parse(item) {
    return {
      id: item.id,
      broadcastName: item.name,
      scheduleDate: item.schedule,
      selectedTemplate: item.template_id,
      selectedContacts: item.selected_contacts.map((con) => new Contact()
                          .setId(con.id)
                          .setName(con.name)
                          .setPhoneNumber(con.phone_number)
                          .setEmail(con.email)),
      selectedGroups: item.selected_groups.map((con) => new Groups()
                          .setId(con.id)
                          .setName(con.name)
                          .setContactsCount(con.contacts_count)
                          .setDescription(con.description)),
      templateVariables: item.template_variables,
      success: item.success,
      failed: item.failed,
      read: item.read,
      replied: item.replied,
      recipients: item.recipients,
      status: item.status,
    }
  }
  serialize(model) {
    return {
      id: model.getId() ?? null,
      name: model.getBroadCastName(),
      send_now: model.getSendNow(),
      selected_contacts: model.getSelectedContacts().map((con) => con.attrs.id),
      selected_groups: model.getSelectedGroups().map((con) => con.attrs.id),
      selected_template: model.getSelectedTemplate(),
      schedule: model.getScheduleDate(),
      template_variables: model.getTemplateVariables(),
    }
  }
  async createBroadCastMessage(model) {
    const url = `/broadcast/${appConfig.getServiceId()}`;
    const { data } = await request.post(url, this.serialize(model));
    return data;
  }

  async updateBroadCastMessage(model) {
    const url = `/broadcast/${appConfig.getServiceId()}`;
    const { data } = await request.put(url, this.serialize(model));
    return data;
  }

  async getAllBroadcast() {
    const url = `/broadcast/${appConfig.getServiceId()}`;
    const { data } = await request.get(url);
    return data.map((model) => new Broadcast(this.parse(model)));

  }
}

export default new BroadcastService();
